export default function Services() {
  return (
    <>
      <div
        className="views-element-container services !px-2 md:!px-20 section-padding"
        id="block-views-block-nv-section-content-block-services-3"
      >
        <div className="container">
          <div className="sec-head custom-font tr-head">
            <h6 id="gradenttext" className="wow  fadeIn leading-[1.8] !font-medium !text-[15px] ">HOW IT WORKS</h6>
            <h3 className="text-white" >SUMMARY!</h3>
            <span className="tbg">SUMMARY!</span>
          </div>
        </div>
        <div className="clearfix"></div>
        <div>
          <div className="container">
            <div className="row">
              <div
                className="col-md-6 col-lg-4 wow fadeInUp"
                data-wow-delay=".3s"
              >
                <div className="step-item !px-6 py-6 xtop">
                  <img src="/img/icon-launch.png" className=" mx-auto " alt="" />
                  <h6 className=" txt font-bold mt-3 text-[16px] text-white !leading-tight" >Launch Your Coin</h6>
                  <p className="wow txt !text-[14.7px] text-[#9EAAC0] !font-normal mt-1 tracking-[0.4px] !leading-normal" >
                    Get tokenised by creating your Profile, adding your Songs &
                    Playlists.
                  </p>
                </div>
              </div>
              <div
                className="col-md-6 col-lg-4 wow fadeInUp"
                data-wow-delay=".6s"
              >
                <div className="step-item !px-6 py-6 xcolor xcenter">
                  <img src="/img/music-chart.png" className=" mx-auto " alt="" />
                  <h6 className=" txt font-bold mt-3 text-[16px] text-white !leading-tight" >Buy, Sell & Trade</h6>
                  <p className="wow txt !text-[14.7px] text-[#9EAAC0] !font-normal mt-1 tracking-[0.4px] !leading-normal" >
                    With Loozr coin, fans can stream and trade Artist Profile,
                    Songs, and Playlist tokens.
                  </p>
                </div>
              </div>
              <div
                className="col-md-6 col-lg-4 wow fadeInUp"
                data-wow-delay=".9s"
              >
                <div className="step-item !px-6 py-6 xbottom  ">
                  <img src="/img/icon-hearts.png" className=" mx-auto " alt="" />
                  <h6 className=" txt font-bold mt-3 text-[16px] text-white !leading-tight" >Collective Wins</h6>
                  <p className="wow txt !text-[14.7px] text-[#9EAAC0] !font-normal mt-1 tracking-[0.4px] !leading-normal" >
                    When fans invest in a token, like Bitcoin, the price of that
                    token price rises. Artistes receive a percentage incentive
                    from these trades in addition to their streaming money.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="clearfix"></div>
    </>
  );
}